import React from "react";
import { FaDolly, FaRedo, FaDollarSign } from "react-icons/fa";

export const serviceData = [
  {
    id: 1,
    icon: <FaDolly className="icon-servicess" />,
    Title: "free shipping",
    text:
      " Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ad fugit perspiciatis, sed accusamus temporibus enim",
  },
  {
    id: 2,
    icon: <FaRedo className="icon-servicess" />,
    Title: "30 days return policy",
    text:
      " Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ad fugit perspiciatis, sed accusamus temporibus enim",
  },
  {
    id: 3,
    icon: <FaDollarSign className="icon-servicess" />,
    Title: "Secured Payment",
    text:
      " Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ad fugit perspiciatis, sed accusamus temporibus enim",
  },
];
